(function () {
    'use strict';

    angular.module("imApp").factory("pickJobGrpBatchAddOService", ['$ihttp', function ($ihttp) {
        let service = {
            getPickJobGrpBatchAddO: function (parms) {
                return $ihttp.post({
                    method: 2248,
                    parameters: parms || {}
                });
            },
            addOrder: function (mergeObj) {
                return $ihttp.post({
                    method: 2250,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
